exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notificationIconComponent-notificationIconContainer {\n  display: flex; }\n\n.notificationIconComponent-notificationBadge {\n  color: var(--text); }\n\n.notificationIconComponent-notificationIcon {\n  color: var(--text);\n  padding-right: 8px;\n  padding-bottom: 5px; }\n\n.notificationIconComponent-redirectLink {\n  text-decoration: none;\n  color: var(--text);\n  padding: 0; }\n", ""]);

// exports
